/**
 * @fileoverview POST handler for the "/:app_group_id/canvas/:workflow_id/copy/:target_app_group_id" endpoint
 */

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { engagementCanvasCopyCacheKeys } from "./constants";
import type { CanvasCopyResult, PostEngagementCanvasCopyProps } from "./types";

export const postCanvasCopy = reactQueryMutationAdapter(
  engagementCanvasCopyCacheKeys,
  ({ canvasId, appGroupId, targetAppGroupId }: PostEngagementCanvasCopyProps): Promise<CanvasCopyResult> => {
    return fetch(`/${appGroupId}/canvas/${canvasId}/copy/${targetAppGroupId}`, "POST", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
